<!--
  ~ Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
  ~ This software is the proprietary information of Irian Software Development SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<span *ngIf="time">
  <span *ngIf="time.days "> {{time.days}} {{'date-utils.days' | translate}} {{time.hours}} {{'date-utils.hours' | translate}} </span>
  <span *ngIf="!time.days && time.hours"> {{time.hours}} {{'date-utils.hours' | translate}} {{time.minutes}} {{'date-utils.minutes' | translate}} </span>
  <span *ngIf="!time.days && !time.hours "> {{time.minutes}} {{'date-utils.minutes' | translate}} {{time.seconds}} {{'date-utils.seconds' | translate}} </span>
</span>
